exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.MobileTicketQRCodeDialog .el-dialog__headerbtn {\r\n  right: 5px;\r\n  top: 5px;\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3ebab48c","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/mobile-ticket/MobileTicketQRCodeDialog.vue
// module id = 589
// module chunks = 75